var now = +new Date();
var index = 0;

export default function uid() {
  return "rc-upload-" + now + "-" + ++index;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.4.4@rc-upload/es/uid.js
// module id = 381
// module chunks = 1